import { render } from "./OrdersValidate.vue?vue&type=template&id=fb5eb2f4&scoped=true"
import script from "./OrdersValidate.vue?vue&type=script&lang=js"
export * from "./OrdersValidate.vue?vue&type=script&lang=js"

import "./OrdersValidate.vue?vue&type=style&index=0&id=fb5eb2f4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5eb2f4"]])

export default __exports__